import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ThemeService } from 'src/app/services/base/theme.service';


@Component({
  selector: 'app-my-small-button',
  templateUrl: './my-small-button.component.html',
  styleUrls: ['./my-small-button.component.scss']
})
export class MySmallButtonComponent implements OnInit {

  @Input() valid:boolean = false;
  @Input() title:string = "";
  @Input() icon:string = "";
  @Output() myClick =  new EventEmitter();
  
  constructor(public theme:ThemeService) { }

  ngOnInit(): void {
  }

  
  onClick(){
    this.myClick.emit();
  }

}
